import { AccountingMappingIcon } from 'seagull/icons';
import { IconButton, Tooltip, Typography } from 'seagull';
import { getAccountingDetails } from "../accounting.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AccountingMappingIndication = props => {
  const {
    display,
    accounting,
    purpose
  } = props;
  const intent = display ? 'success' : 'pending';
  const testIdPrefix = "".concat(getAccountingDetails(accounting).testIdPrefix, "-").concat(purpose === 'customer' ? 'customer' : 'service');
  const getTooltipTitle = () => {
    if (display) return /*#__PURE__*/_jsxs(Typography, {
      skin: "invertedStandard",
      children: ["Mapped to", ' ', /*#__PURE__*/_jsx(Typography, {
        as: "span",
        weight: "bold",
        skin: "invertedStandard",
        children: display
      }), ' ', "in ", getAccountingDetails(accounting).fullName]
    });
    return /*#__PURE__*/_jsxs(Typography, {
      skin: "invertedStandard",
      children: ["Missing ", getAccountingDetails(accounting).fullName, " mapping"]
    });
  };
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "".concat(testIdPrefix, "-map-indication"),
    children: /*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      title: /*#__PURE__*/_jsx("div", {
        "data-testid": "".concat(testIdPrefix, "-map-tooltip"),
        children: getTooltipTitle()
      }),
      children: /*#__PURE__*/_jsx(IconButton, {
        cursorDefault: true,
        skin: "transparent",
        children: /*#__PURE__*/_jsx(AccountingMappingIcon, {
          size: 18,
          intent: intent
        })
      })
    })
  });
};